import axios from "axios";
import React from "react";
import Moment from 'moment';

import {Link} from "react-router-dom";
import {translate} from "react-i18next";
import Cookies from "universal-cookie";
import {Growl} from 'primereact/growl';

import User from "./../../util/User";

import { Calendar } from 'primereact/calendar';

// See https://facebook.github.io/react/docs/forms.html for documentation about
// forms.
class UserData extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
			id          : -1,
			firstname	: '',
			lastname		: '',
			username		: '',
			dateOfBirth	: '',
			email		: '',
			sending		: false
        };
        
        this.handleFirstnameChange		= this.handleFirstnameChange.bind(this);
        this.handleLastnameChange		= this.handleLastnameChange.bind(this);
        this.handleDateOfBirthChange     = this.handleDateOfBirthChange.bind(this);
        this.handleEmailChange			= this.handleEmailChange.bind(this);
        this.handleSubmit				= this.handleSubmit.bind(this);
        this.cookies = this.props.cookies;
    }

    componentWillMount() {
    		if(!User.isAuthenticated()) {
    			return;
    		}

    		axios.get(global.BACKEND_URL + `/user/${User.id}`)
            .then(({data, status}) => {
                this.state.id           = data.id;
				this.state.firstname	= data.firstname;
				this.state.lastname		= data.lastname;
				this.state.email		= data.email		|| '';
				this.state.dateOfBirth	= new Date(data.dateOfBirth) || '';
				this.state.username		= data.username;
                this.setState(this.state);
            });
    }
    
    handleFirstnameChange(event) {
	    this.state.firstname	= event.target.value;
	    	this.setState(this.state);
    }

    handleLastnameChange(event) {
	    this.state.lastname = event.target.value;
	    	this.setState(this.state);
    }
    
    handleDateOfBirthChange(event) {
	    this.state.dateOfBirth = event.target.value
	    	this.setState(this.state);
    }
    
    handleUsernameChange(event) {
	    this.state.username = event.target.value;
	    	this.setState(this.state);
    }
    
    handleEmailChange(event) {
	    this.state.email = event.target.value;
    		this.setState(this.state);
    }
    
    handleSubmit(event) {
        event.preventDefault();
        
        if(this.state.sending)
        		return;

		const {t} = this.props;
        
        this.state.sending = true;
        this.setState(this.state);

        axios.post(global.BACKEND_URL + '/user/save',
               {
				    id					: this.state.id,
	           		firstname			: this.state.firstname,
	           		lastname			: this.state.lastname,
					dateOfBirth			: this.state.dateOfBirth,
					username			: this.state.username,
					email				: this.state.email,
                })
                .then(({data, status}) => {
                     this.state.sending = false;
                     this.setState(this.state);
                     
                     const {t} = this.props;
                     switch (status) {
                         case 200:

                             var data = this.state;
                             data.id = User.id;
                             
                             User.set(data);
                             
                             const cookies = new Cookies();
                             const auth = cookies.get('auth');

                             auth["user"] = data;
                             cookies.set('auth', auth);
                             
							 this.growl.show({severity: 'success', 
								  summary: t('savingSuccessfull'), detail: '-'});
                             break;
                         case 400:
							this.growl.show({severity: 'error', 
								  summary: t('savingFailed'), detail: '-'});
                            break;
                         case 401:
                         	console.log(data, "not permitted");
                            	break;
                     }
                });
    }
    
    render() {
        const {t} 		= this.props;
        const firstname 	= this.state.firstname;
        const lastname 	= this.state.lastname;

        return (
	       <div className="container marketing no-banner">
	        	<div className='page-header'>
	        	      <h3>{t("userData")}</h3>
	        	</div>
				<Growl ref={(el) => this.growl = el} />
	     	
	        	{User.levelOfDetail > 1 &&
			    <div className="alert alert-info">
                    <span className="glyphicon glyphicon-info-sign" aria-hidden="true"></span>
                    <span className="sr-only">Info:</span>&nbsp;
	        			{t("userCockpitDescr").replace("%User.firstname%", firstname).replace("%User.lastname%", lastname)}
				</div>
		    } 
	        	   <form onSubmit={this.handleSubmit} className="row">
		        		<fieldset>
				            <div className="form-group col-md-6 col-lg-6">
				               <label htmlFor="firstname">{t('firstname')}</label>
				               <input type="text" name="firstname" id="firstname" className="form-control" value={this.state.firstname} onChange={this.handleFirstnameChange} />
				            </div> 
				            <div className="form-group col-md-6 col-lg-6">
				               <label htmlFor="lastname">{t('lastname')}</label>
				               <input type="text" name="lastname" id="lastname" className="form-control" value={this.state.lastname} onChange={this.handleLastnameChange} />
				            </div>
				            <div className="form-group col-md-6 col-lg-6">
				               <label htmlFor="username">{t('username')}</label>
				               <input type="text" name="username" id="username" className="form-control" value={this.state.username} onChange={this.handleUsernameChange} />
				            </div>
                           <div className="form-group col-md-6 col-lg-6">
                             <label htmlFor="dateOfBirth">{t('dateOfBirth')}</label>
							 <Calendar className="form-control" 
							 	value={this.state.dateOfBirth} onChange={(e) => this.setState({dateOfBirth: e.value})}></Calendar>
                          </div> 
					</fieldset>
						
	        		<fieldset>
					      <div className="form-group col-lg-6 col-md-6">
					         <label htmlFor="email">{t('email')}</label>
					         <input type="text" name="email" id="email" className="form-control" value={this.state.email} onChange={this.handleEmailChange} />
					      </div> 
					</fieldset>
						
						<div className="form-actions container">
			            {!this.state.sending ?
	            				<button type="submit" className="btn btn-primary">{t('save')}</button>
	            				: <button className="btn btn-default"><img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="></img></button> }
				        </div>
	        	    </form>
	        	</div>
        );
    }
}

export default translate()(UserData);